import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencySection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4 bg-gradient-to-b from-red-950/20 to-transparent" data-id="element-180">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-181">
        <AlertTriangleIcon className="w-16 h-16 text-red-500 mx-auto" data-id="element-182" />

        <h3 className="text-2xl md:text-3xl font-bold" data-id="element-183">
          Cada mes entran más profesores al mercado.
        </h3>

        <div className="space-y-4 text-lg md:text-xl" data-id="element-184">
          <p className="text-primary font-semibold" data-id="element-185">
            Los que se adaptan crecen.
          </p>
          <p className="text-gray-300" data-id="element-186">
            Los demás siguen compitiendo por precio… y luchando por llenar su
            agenda.
          </p>
        </div>

        <div className="bg-red-600/20 border border-red-500 rounded-lg p-6 mt-8" data-id="element-187">
          <p className="text-sm uppercase tracking-wide mb-2" data-id="element-188">
            Esta oferta expira en:
          </p>
          <CountdownTimer className="text-3xl md:text-4xl text-red-400" data-id="element-189" />
        </div>
      </div>
    </motion.section>;
}